// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetReviewsRequest,
  TGetReviewsModel,
  IMappers,
  TGetReviewsResponse,
  IGetReviewsResponse,
  IGetReviewsResponseError,
} from './types';

export const defaultConfig: TGetReviewsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-reviews',
  pathApi: '/v1/get-reviews/',
  requestType: 'json',
} as TGetReviewsModel;

export function createGetReviewsModel(parameters: IGetReviewsRequest): TGetReviewsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetReviewsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetReviewsRequest;
}

export async function fetchGetReviews<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetReviewsOptions<TResponse200, TResponse400>): Promise<TGetReviewsResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetReviewsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetReviewsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetReviewsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetReviewsResponse;
}
